import { render, staticRenderFns } from "./error-conversation-not-found.vue?vue&type=template&id=5e270fea&scoped=true&"
import script from "./error-conversation-not-found.vue?vue&type=script&lang=js&"
export * from "./error-conversation-not-found.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e270fea",
  null
  
)

export default component.exports